import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { tanimlarApi } from '../services/api';
import DataTable, { DtColumn } from '../components/DataTable';
import { GUNCEL_AY, cozGuncelAy } from '../utils/guncelAy';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const token = () => localStorage.getItem('token');
const headers = () => ({ Authorization: `Bearer ${token()}` });

async function getTanimlar(modul: string) {
  const res = await fetch(`${API}/api/tanimlar2/liste?modul=${modul}&sadece_yaprak=true`, { headers: headers() });
  return res.ok ? res.json() : [];
}

const YIL = new Date().getFullYear();
const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

const emptyForm = { isletme_id: '', yil: YIL, ay: 12, urun_kod: '', urun: '', alan_da: 0, uretim_kg: 0, aciklama: '' };

export default function BahceBitkileri() {
  const [kayitlar,   setKayitlar]   = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [urunler,    setUrunler]    = useState<any[]>([]);
  const [ozet,       setOzet]       = useState<any>(null);
  const [modalAcik,  setModalAcik]  = useState(false);
  const [form,       setForm]       = useState<any>({ ...emptyForm });
  const [filtre,     setFiltre]     = useState((() => {
    const sp = new URLSearchParams(window.location.search);
    return {
      isletme_id: sp.get('isletme') || '',
      yil: Number(sp.get('yil') || YIL),
      ay: sp.get('ay') || GUNCEL_AY
    };
  })());
  const [hata,       setHata]       = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const userStr = localStorage.getItem('user');
  const user    = userStr ? JSON.parse(userStr) : null;
  const isGM    = user?.rol && ['super_admin','gm_yonetici','gm_personel'].includes(user.rol);
  const isAdmin = user?.rol && ['super_admin','gm_yonetici'].includes(user.rol);

  const [kiralikGoster, setKiralikGoster] = useState(false);

  useEffect(() => {
    if (!isGM && user?.isletme_id) setFiltre(f => ({ ...f, isletme_id: user.isletme_id }));
    getTanimlar('bahce_urun').then(setUrunler);
  }, []);

  useEffect(() => {
    tanimlarApi.isletmelerListesi(kiralikGoster).then(r => setIsletmeler(r.data));
  }, [kiralikGoster]);

  useEffect(() => { yukle(); }, [filtre]);

  const [cozulenAy, setCozulenAy] = useState<number | null>(null);

  const yukle = async () => {
    let ay: any = filtre.ay;
    if (ay === GUNCEL_AY) {
      ay = await cozGuncelAy(filtre.yil, filtre.isletme_id, (params: any) =>
        axios.get(`${API}/api/bitkisel/bahce`, { headers: headers(), params }));
      setCozulenAy(ay);
    } else {
      setCozulenAy(null);
    }
    const p: any = { yil: filtre.yil };
    if (filtre.isletme_id) p.isletme_id = filtre.isletme_id;
    if (ay) p.ay = Number(ay);
    axios.get(`${API}/api/bitkisel/bahce`, { headers: headers(), params: p }).then(r => setKayitlar(r.data)).catch(() => setKayitlar([]));
    axios.get(`${API}/api/bitkisel/bahce/ozet`, { headers: headers(), params: p }).then(r => setOzet(r.data)).catch(() => setOzet(null));
  };

  const urunAdi = (kod: string) => urunler.find(u => u.kod === kod)?.ad || kod;

  const [secili, setSecili] = useState<any>(null);
  const duzenleAc = (k: any) => { setSecili(k); setForm({ ...k }); setHata(''); setModalAcik(true); };

  const kaydet = async () => {
    if (!form.isletme_id) { setHata('İşletme seçiniz'); return; }
    if (!form.urun_kod)   { setHata('Ürün seçiniz');    return; }
    setHata(''); setYukleniyor(true);
    try {
      const data = { ...form, isletme_id: Number(form.isletme_id), urun: urunAdi(form.urun_kod) };
      if (secili) {
        await axios.put(`${API}/api/bitkisel/bahce/${secili.id}`, data, { headers: headers() });
      } else {
        await axios.post(`${API}/api/bitkisel/bahce`, data, { headers: headers() });
      }
      yukle(); setModalAcik(false); setSecili(null); setForm({ ...emptyForm });
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
    finally { setYukleniyor(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Silmek istiyor musunuz?')) return;
    try { await axios.delete(`${API}/api/bitkisel/bahce/${id}`, { headers: headers() }); yukle(); } catch {}
  };

  const silSecili = async (rows: any[]) => {
    for (const k of rows) await axios.delete(`${API}/api/bitkisel/bahce/${k.id}`, { headers: headers() });
    yukle();
  };

  const n = (v: any) => Number(v || 0).toLocaleString('tr-TR');
  const f = (v: any) => Number(v || 0).toLocaleString('tr-TR', { maximumFractionDigits: 1 });

  const columns: DtColumn[] = [
    { key: 'isletme', label: 'İşletme', sortable: true, filterable: true, render: (k: any) => <><strong>{k.isletme_kod}</strong><br /><small>{k.isletme_ad}</small></>, sortValue: (k: any) => k.isletme_kod || '', filterValue: (k: any) => k.isletme_ad || '', exportValue: (k: any) => `${k.isletme_kod} ${k.isletme_ad}` },
    { key: 'yil', label: 'Yıl', sortable: true, filterable: true, sortValue: (k: any) => Number(k.yil), filterValue: (k: any) => String(k.yil) },
    { key: 'ay', label: 'Ay', sortable: true, filterable: true, render: (k: any) => AYLAR[k.ay] || k.ay, filterValue: (k: any) => AYLAR[k.ay] || String(k.ay), sortValue: (k: any) => Number(k.ay) },
    { key: 'urun', label: 'Ürün', sortable: true, filterable: true, render: (k: any) => <>{k.urun}{k.urun_kod && <><br /><small style={{color:'#999',fontSize:10}}>{k.urun_kod}</small></>}</>, filterValue: (k: any) => k.urun || '' },
    { key: 'alan_da', label: 'Alan (da)', sortable: true, render: (k: any) => n(k.alan_da), sortValue: (k: any) => Number(k.alan_da || 0) },
    { key: 'uretim_kg', label: 'Üretim (kg)', sortable: true, render: (k: any) => n(Math.round(k.uretim_kg)), sortValue: (k: any) => Number(k.uretim_kg || 0) },
    { key: 'islem', label: 'İşlem', noExport: true, render: (k: any) => (
      <div style={{ display: 'flex', gap: 4 }}>
        {isAdmin && <button className="btn btn-primary btn-sm" onClick={() => duzenleAc(k)}>Düzenle</button>}
        <button className="btn btn-danger btn-sm" onClick={() => sil(k.id)}>Sil</button>
      </div>
    )},
  ];

  return (
    <div>
      <div className="page-header">
        <h1>🌳 Bahçe Kültürleri</h1>
        <p>İşletme bazında yıllık bahçe kültürleri üretim verileri</p>
      </div>

      {ozet && (
        <div className="stats-grid">
          <div className="stat-card"><div className="stat-icon">🌳</div><div><div className="stat-value">{n(Math.round(ozet.toplam_alan_da))}</div><div className="stat-label">Toplam Alan (da)</div></div></div>
          <div className="stat-card"><div className="stat-icon">🍎</div><div><div className="stat-value">{n(Math.round(ozet.toplam_uretim_kg))}</div><div className="stat-label">Üretim (kg)</div></div></div>
          <div className="stat-card"><div className="stat-icon">📋</div><div><div className="stat-value">{ozet.kayit_sayisi}</div><div className="stat-label">Kayıt Sayısı</div></div></div>
        </div>
      )}

      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8 }}>
            <input type="number" className="search-input" style={{ width: 90 }} value={filtre.yil}
              onChange={e => setFiltre({ ...filtre, yil: Number(e.target.value) })} placeholder="Yıl" />
            <select className="search-input" style={{ width: 120 }} value={filtre.ay}
              onChange={e => setFiltre({ ...filtre, ay: e.target.value })}>
              <option value={GUNCEL_AY}>Güncel Ay{cozulenAy ? ` (${AYLAR[cozulenAy]})` : ''}</option>
              <option value="">Tüm Aylar</option>
              {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
            </select>
            {isGM && (
              <>
                <select className="search-input" style={{ width: 210 }} value={filtre.isletme_id}
                  onChange={e => setFiltre({ ...filtre, isletme_id: e.target.value })}>
                  <option value="">Tüm İşletmeler</option>
                  {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                </select>
                <label style={{ display:'flex', alignItems:'center', gap:4, fontSize:13, cursor:'pointer', whiteSpace:'nowrap' }}>
                  <input type="checkbox" checked={kiralikGoster} onChange={e => setKiralikGoster(e.target.checked)} />
                  Kiralıkları Göster
                </label>
              </>
            )}
          </div>
          <button className="btn btn-success" onClick={() => { setForm({ ...emptyForm, isletme_id: isGM ? '' : user?.isletme_id }); setHata(''); setModalAcik(true); }}>+ Yeni Kayıt</button>
        </div>

        <DataTable columns={columns} data={kayitlar} rowKey={(k: any) => k.id} onDeleteSelected={silSecili} exportFilename="bahce-kulturleri" />
      </div>

      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 480 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>🌳 Bahçe Kültürü Kayıt Girişi</h3><button className="modal-close" onClick={() => setModalAcik(false)}>×</button></div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}
              <div className="form-row">
                {isGM && (
                  <div className="form-group"><label>İşletme *</label>
                    <select className="form-control" value={form.isletme_id} onChange={e => setForm({ ...form, isletme_id: e.target.value })}>
                      <option value="">Seçiniz</option>
                      {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                    </select>
                  </div>
                )}
                <div className="form-group"><label>Yıl *</label>
                  <input className="form-control" type="number" value={form.yil} onChange={e => setForm({ ...form, yil: Number(e.target.value) })} />
                </div>
                <div className="form-group"><label>Ay *</label>
                  <select className="form-control" value={form.ay} onChange={e => setForm({ ...form, ay: Number(e.target.value) })}>
                    {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-group"><label>Ürün * <small style={{color:'#999',fontWeight:'normal'}}>({urunler.length} ürün)</small></label>
                <select className="form-control" value={form.urun_kod} onChange={e => setForm({ ...form, urun_kod: e.target.value })}>
                  <option value="">Seçiniz</option>
                  {urunler.map(u => <option key={u.kod} value={u.kod}>{u.ad} ({u.kod})</option>)}
                </select>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Alan (da)</label><input className="form-control" type="number" value={form.alan_da} onChange={e => setForm({ ...form, alan_da: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Üretim (kg)</label><input className="form-control" type="number" value={form.uretim_kg} onChange={e => setForm({ ...form, uretim_kg: Number(e.target.value) })} /></div>
              </div>
              <div className="form-group"><label>Açıklama</label><textarea className="form-control" value={form.aciklama} onChange={e => setForm({ ...form, aciklama: e.target.value })} rows={2} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet} disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
